// ©2024 Austin App House. All rights reserved.
const values = {};

export default values;
